//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class PropertyModel extends ModelBase {
      static readonly $typeName = 'PropertyModel';
      public key: string;
      public isActive: boolean;
      public inRule: boolean;
      public columnLength: number;
      public columnLengthErrorMessage: string;
      public description: string;
      public isKeyField: boolean;
      public name: string;
      public type: string;
      public valueSet: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/PropertyModel.ts